import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
// Used for modal dialogs with backdrop close and escape key support
export default class extends Controller {
  static targets = ["content"]

  close() {
    this.element.classList.add("hidden")
  }

  closeOnBackdrop(event) {
    // Only close if clicking on the backdrop, not the content
    if (event.target === this.element) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }
}
